// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"c68315aa","495":"937f37b3","612":"c68315aa","652":"937f37b3"}[chunkId] + ".chunk.css";
};